import React, { useCallback, useMemo } from 'react';
import { doesArrayHasLength } from '../../../utils/isDefined';
import { InputAdornment, TextField, withStyles } from '@material-ui/core';

import styles from '../styles/answerPhones';
import Optional from '../../../utils/optional';
import clsx from 'clsx';
import flowRight from 'lodash.flowright';
import withSettings from '../../../utils/withSettings';
import { translate } from '../../../i18n/I18nProvider';

const AnswerPhones = ({ data, classes, setFieldValue, settings }) => {
  const mobilePhones = useMemo(() => data.filter(el => el.type === 'MOBILE'), [
    data
  ]);

  const onDeleteNumber = useCallback(
    number => {
      const updatedData = data.reduce((arr, el) => {
        if (el.type !== 'MOBILE' || el.value !== number) {
          return [...arr, el];
        }

        return arr;
      }, []);
      setFieldValue('answer_places', updatedData);
    },
    [data, setFieldValue]
  );

  return (
    <div className={classes.root}>
      {doesArrayHasLength(mobilePhones) ? (
        mobilePhones.map((phoneLine, index) => (
          <TextField
            className={classes.phoneLine}
            key={index}
            variant="outlined"
            margin="dense"
            value={Optional(phoneLine?.value).or('')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <i
                    className={clsx('far fa-trash-alt', classes.deleteIcon)}
                    onClick={() => onDeleteNumber(phoneLine.value)}
                    style={{ color: settings?.colors.modal_header }}
                  ></i>
                </InputAdornment>
              )
            }}
          />
        ))
      ) : (
        <div className={classes.noData}>
          {translate('USER.NO_MOBILE_PHONES')}
        </div>
      )}
    </div>
  );
};

export default flowRight(withSettings, withStyles(styles))(AnswerPhones);
